<template>
  <FilterConditions :config="inputConfig" />
  <TableDate :config="tableConfig" />
</template>

<script setup>
import { ref } from "vue"
import FilterConditions from "./packages/FilterConditions/index.vue"
import TableDate from "./packages/tableData/index.vue"

const props = defineProps(['inputConfig', 'tableConfig'])

</script>